import PageChristmasSpirits2024Index from "./pages/ChristmasSpirits2024/Index.js";
import PageChristmasSpirits2024ThankYou from "./pages/ChristmasSpirits2024/ThankYou.js";
import PageCommon from "./pages/PageCommon.js";

export default class ChristmasSpirits2024 {
	static factory(cls) {
		return new ChristmasSpirits2024.classes[cls]();
	}
}

ChristmasSpirits2024.classes = { PageCommon, PageChristmasSpirits2024Index, PageChristmasSpirits2024ThankYou };